import * as yup from 'yup'

import formatYupError from '../../../util/formatYupError'
import { isAdmin, isGR } from '../../../util/profiles'
import { getMessage } from '../../../util/IntlMessages'

const schemas = {
  period: yup.object().shape({
    periods: yup.array().of(yup.string()).min(1, getMessage('mandatoryField')).required(getMessage('mandatoryField'))
  }),
  organization: yup.object().shape({
    organization: yup.string().required(getMessage('mandatoryField'))
  }),
  region: yup.object().shape({
    reportFilterRegional: yup
      .array()
      .of(yup.string())
      .min(1, getMessage('mandatoryField'))
      .required(getMessage('mandatoryField'))
  }),
  district: yup.object().shape({
    reportFilterDistrict: yup
      .array()
      .of(yup.string())
      .min(1, getMessage('mandatoryField'))
      .required(getMessage('mandatoryField'))
  }),
  actionType: yup.object().shape({
    reportFilterActionType: yup.string().required(getMessage('mandatoryField'))
  })
}

export async function validateFilters({ applyFilter, setErrors, userAuth, formValues, isReportActionDetail }) {
  try {
    if (isReportActionDetail) {
      await schemas.actionType.validate(formValues, { abortEarly: false })
    }
    await validateReportPeriod(formValues)
    await validateReportOrganization(formValues)
    switch (true) {
      case isAdmin(userAuth):
        break
      case isGR(userAuth):
        await schemas.region.validate(formValues, { abortEarly: false })
        break
      default:
        await schemas.region.validate(formValues, { abortEarly: false })
        await schemas.district.validate(formValues, { abortEarly: false })
        break
    }
    applyFilter()
    setErrors({})
  } catch (error) {
    setErrors(formatYupError(error))
  }
}

async function validateReportOrganization(formValues) {
  const reportType = formValues.reportFilterType
  const reportsWithMandatoryOrganization = [
    'ACTION_PLAN',
    'CADASTRO_ELEITOS',
    'CARTEIRA_DE_ELEITOS',
    'ELEITOS_E_ALTERNATIVOS',
    'ARRASTAO',
    'FORECAST',
    'VISITAS',
    'VISITAS_DETALHADA'
  ]
  if (reportsWithMandatoryOrganization.includes(reportType)) {
    await schemas.organization.validate(formValues, { abortEarly: false })
  }
}

async function validateReportPeriod(formValues) {
  const reportType = formValues.reportFilterType
  const reportsWithMandatoryPeriod = ['ACTION_PLAN', 'CARTEIRA_DE_ELEITOS', 'FORECAST', 'VISITAS', 'VISITAS_DETALHADA']
  if (reportsWithMandatoryPeriod.includes(reportType)) {
    await schemas.period.validate(formValues, { abortEarly: false })
  }
}
